import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CircularProgress from '@mui/material/CircularProgress';
import Link from '@mui/material/Link';
import { CenteredDialogContent } from "../styles/styledComponents";

const ENDPOINT_TEST_URL =  process.env.REACT_APP_TEST_ENDPOINT;

interface UploadDialogProps {
    endpointName: string;
    open: boolean;
    uploading: boolean;
    closeDialog: () => void;
}

export function UploadDialog({
    endpointName,
    open,
    uploading,
    closeDialog
}: UploadDialogProps) {
    const uploadingComponent = <>
        <DialogTitle>Uploading {endpointName}</DialogTitle>
        <CenteredDialogContent>
            <CircularProgress />
        </CenteredDialogContent>
    </>

    const ENDPOINT = `${ENDPOINT_TEST_URL}/${endpointName}`;
    const uploadSuccessComponent = <>
        <DialogTitle>Upload Success</DialogTitle>
        <DialogContent>
            <Typography>
                {`Successfully uploaded ${endpointName}`}
                You can test your new endpoint here:
                <Link 
                    target="_blank"
                    href={`${ENDPOINT}`}>
                    {ENDPOINT}
                </Link>
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={closeDialog}>Close</Button>
        </DialogActions>
    </>

    return (<Dialog open={open}>
        {uploading && uploadingComponent}
        {!uploading && uploadSuccessComponent}
    </Dialog>);
}
